const messages = {
  name: 'Gestion de Usuarios |||| Gestion de Usuarios',
  fields: {
    scopesPerAccount: 'Permisos por cuenta',
    name: 'Nombre',
    surname: 'Apellido',
    email: 'Email',
    phone: 'Telefono',
    telegramChatId: 'Chat ID de Telegram',
    scopes: 'Acceso a',
    aiCapabilities: 'IA',
    canUseContactCenterAi: 'Puede usar IA en contact center',
    canEditKnowledgeBase: 'Puede editar base de conocimiento',
    status: 'Estado',
    accounts: 'Cuentas',
    notifyStaff: 'Personal de contact center de Roommatik',
    notifyStaffHelp: 'Puede leer y escribir el diario interno, el que el hotel no ve. Es un rol de SSO, no un permiso de la cuenta: el hotel no puede concederselo.',
    account: 'Cuenta',
    role: 'Rol',
    password: 'Contrasena',
    confirmPassword: 'Confirmar Nueva Contrasena',
    newPassword: 'Nueva Contrasena',
  },
  columns: {
    actions: 'Acciones',
  },
  filters: {
    name: 'Nombre',
    surname: 'Apellido',
    email: 'Email',
    role: 'Rol',
    allRoles: 'Todos los Roles',
  },
  scopes: {
    portal: 'Portal',
    'contact-center': 'Connect',
    'contact-center-config': 'Configurar Connect',
    'knowledge-base': 'Base de conocimientos',
    'automations': 'Flow',
    'manage-users': 'Gestionar usuarios',
    app: 'App',
  },
  capabilities: {
    ai: 'IA',
    kb: 'KB',
  },
  status: {
    active: 'Activo',
    blocked: 'Bloqueado',
  },
  deleteHard: {
    title: 'Eliminar definitivamente a %{email}?',
    content: 'Se borra su identidad SSO (pierde acceso a todas las cuentas) y su ficha. Esta accion NO es reversible. Si solo quieres impedirle entrar, usa Bloquear.',
  },
  actions: {
    addUser: 'Anadir Usuario',
    block: 'Bloquear (no podra entrar; conserva sus cuentas)',
    unblock: 'Desbloquear',
    deleteHard: 'Eliminar definitivamente',
    changePassword: 'Cambiar Contrasena',
  },
  roles: {
    superUser: 'SuperUser',
    maintenance: 'Maintenance',
    accountUser: 'Usuario de Cuenta',
  },
  dialog: {
    userDetails: 'Detalles del Usuario',
    changePassword: 'Cambiar Contrasena',
  },
  validation: {
    emailRequired: 'El email es obligatorio',
    emailInvalid: 'Introduce un email valido',
    roleRequired: 'El rol es obligatorio',
    passwordRequired: 'La contrasena es obligatoria',
    passwordMinLength: 'La contrasena debe tener al menos 12 caracteres',
    passwordPattern:
      'La contrasena debe tener al menos una mayuscula, una minuscula, un numero y un caracter especial',
    confirmPasswordRequired: 'Confirma la contrasena',
    confirmPasswordMismatch: 'Las contrasenas no coinciden',
  },
  help: {
    scopesEditedInAccount: 'Se editan en Cuentas → Usuarios: es el único sitio que sabe qué productos tiene contratado cada cuenta.',
    noAccounts: 'Este usuario no pertenece a ninguna cuenta.',
    noScopes: 'Sin permisos',
    passwordPolicy:
      'Minimo 12 caracteres, con una mayuscula, una minuscula, un numero y un simbolo.',
  },
  notifications: {
    blocked: 'Usuario bloqueado.',
    unblocked: 'Usuario desbloqueado.',
    deletedHard: 'Usuario eliminado definitivamente.',
    created: 'Usuario creado correctamente',
    updated: 'Usuario actualizado correctamente',
    createFailed: 'Error al crear el usuario',
    updateFailed: 'Error al actualizar el usuario',
    loadUserFailed: 'Error al cargar los detalles del usuario',
    passwordReset: 'Contrasena actualizada correctamente',
    passwordResetFailed: 'Error al actualizar la contrasena',
  },
};

export default messages;
